import { ReactNode } from 'react';
import { Body } from './Body';
import { FileRouteTypes } from '@tanstack/react-router';
import { useArcadeStoreState } from '@src/hooks/useArcadeStoreState';
import { ArcadeStoreHeader } from './ArcadeStoreHeader';

type HomePageProps = {
  children: ReactNode;
  backRoute?: FileRouteTypes['to'];
  title?: string;
};

export const HomePage = ({ children }: HomePageProps) => {
  const { isPuzzleWalletWebview } = useArcadeStoreState();

  return (
    <div className={`flex h-dvh min-h-dvh flex-col overflow-y-scroll pb-safe`}>
      <ArcadeStoreHeader isHomePage />
      <Body showFooter={!isPuzzleWalletWebview}>{children}</Body>
    </div>
  );
};
